module.exports = __webpack_public_path__ + "static/media/Drawdown3ReducingSources.dcf64d54.jpg";